<template>
    <div v-if="!loadingPage">
        <div v-if="isAdminIdentityVerified" class="pb-2">
            <div class="d-flex justify-content-between align-items-center">
                <h3 class="mb-2 text-primary">امتیاز و نظرات مشتریان</h3>
                <div class="mb-2">
                    <b-button @click="getCustomerCommentsSettings" :disabled="loadingButton" variant="primary"
                        class="px-2">
                        <span>تنظیمات</span>
                    </b-button>
                </div>
            </div>
            <b-row>
                <b-col md="3" class="mt-25">
                    <b-form-group label="تاریخ شروع" label-for="fromId">
                        <b-form-input id="fromId" class="text-center main-input font-weight-bolder pointer"
                            :value="parameters.from ? formatDate(parameters.from) : null" autocomplete="off"
                            name="fromId" />
                        <date-picker v-model="parameters.from" :max="currentDate" format="YYYY-MM-DD"
                            display-format="jYYYY-jMM-jDD" custom-input="#fromId" />
                    </b-form-group>
                </b-col>
                <b-col md="3" class="mt-25">
                    <b-form-group label="تاریخ پایان" label-for="toId">
                        <b-form-input id="toId" class="text-center main-input font-weight-bolder pointer" name="toId"
                            :value="parameters.to ? formatDate(parameters.to) : null" autocomplete="off" />
                        <date-picker v-model="parameters.to" :max="currentDate" format="YYYY-MM-DD"
                            display-format="jYYYY-jMM-jDD" custom-input="#toId" />
                    </b-form-group>
                </b-col>
                <b-col md="3" class="mt-25">
                    <b-form-group label="وضعیت" label-for="statusId">
                        <v-select v-model="parameters.status" :searchable="false" dir="rtl" :options="statusManagement"
                            class="bg-white" id="isReturnedId" autocomplete="off" :reduce="(value) => value.id"
                            style="border-radius: 6px;" label="name" :clearable="false">
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-form-group>
                </b-col>
                <b-col md="3" class="mt-md-2 mt-1">
                    <b-button variant="info" @click="getCustomerComments" :disabled="loading"
                        class="mt-md-25 mt-0 d-flex justify-content-center w-100">
                        <span>اعمال فیلتر</span>
                        <b-spinner v-if="loading" variant="white" class="ml-50" small></b-spinner>
                    </b-button>
                </b-col>
            </b-row>
            <div class="mt-2 mt-md-1">
                <b-card class="p-0" no-body>
                    <b-overlay v-if="comments.length" :show="loading" variant="transparent" opacity="1" blur="3px"
                        rounded="sm">
                        <b-table responsive :items="comments" :fields="fields" class="mb-0" striped>
                            <template #cell(details)="data">
                                <feather-icon @click="showDetails(data.item)" size="20" icon="InfoIcon"
                                    class="pointer text-info" color="#8d88a3" />
                            </template>
                            <template #cell(customer)="data">
                                {{ data.item.customerFirstName ? `${data.item.customerFirstName}
                                ${data.item.customerLastName}` : 'مشتری مجموعه' }}
                            </template>
                            <template #cell(rate)="data">
                                <div v-if="!data.item.rate">
                                    -
                                </div>
                                <div v-else>
                                    <b-img v-for="n in data.item.rate" :key="`rate_1_${n}`"
                                        src="@/assets/images/icon/star.svg" alt="logo"
                                        style="width: 19px; height:19px;" />
                                </div>
                            </template>
                            <template #cell(status)="data">
                                <div :class="status_management_color(data.item.status)">
                                    {{ status_management(data.item.status) }}
                                </div>
                            </template>
                            <template #cell(createdAt)="data">
                                <span>
                                    {{ new Date(data.item.createdAt).toLocaleDateString('fa-IR') }}
                                </span>
                                <span> - </span>
                                <span>
                                    {{ new
                                        Date(data.item.createdAt).toLocaleTimeString('fa-IR').split(":").slice(0,
                                            2).join(":") }}
                                </span>
                            </template>
                        </b-table>
                    </b-overlay>
                    <div v-else class="text-center py-4">
                        موردی وجود ندارد
                    </div>
                </b-card>
                <b-pagination align="center" @input="getCustomerComments" v-model="parameters.pageIndex"
                    :total-rows="parameters.totalCount" :per-page="parameters.pageSize" />
            </div>

            <!------------------------------- modal comments details ------------------------------->
            <b-modal id="comments-details" title="جزئیات نظر" centered :hide-footer="true"
                title-class="font-weight-bolder" size="lg">
                <div v-if="commentDetails" class="px-1 pb-1">
                    <b-row>
                        <b-col lg="6" md="12" class="mt-2">
                            <div class="d-flex align-items-center justify-content-between">
                                <div>
                                    <h5 class="text-secondary">تاریخ ثبت</h5>
                                    <h4 class="mb-0">
                                        <span>
                                            {{ new Date(commentDetails.createdAt).toLocaleDateString('fa-IR') }}
                                        </span>
                                        <span> - </span>
                                        <span>
                                            {{ new
                                                Date(commentDetails.createdAt).toLocaleTimeString('fa-IR').split(":").slice(0,
                                                    2).join(":") }}
                                        </span>
                                    </h4>
                                </div>
                                <b-media no-body>
                                    <b-media-aside class="mr-0">
                                        <b-avatar rounded size="48" variant="light-info">
                                            <feather-icon size="20" icon="CalendarIcon" />
                                        </b-avatar>
                                    </b-media-aside>
                                </b-media>
                            </div>
                        </b-col>
                        <b-col lg="6" md="12" class="mt-2">
                            <div class="d-flex align-items-center justify-content-between">
                                <div>
                                    <h5 class="text-secondary">نام مشتری</h5>
                                    <h4 v-if="commentDetails.customerFirstName" class="mb-0">
                                        {{ commentDetails.customerFirstName + " " +
                                            commentDetails.customerLastName }}
                                    </h4>
                                    <h4 v-else class="mb-0">
                                        مشتری مجموعه
                                    </h4>
                                </div>
                                <b-media no-body>
                                    <b-media-aside class="mr-0">
                                        <b-avatar rounded size="48" variant="light-info">
                                            <feather-icon size="20" icon="UserIcon" />
                                        </b-avatar>
                                    </b-media-aside>
                                </b-media>
                            </div>
                        </b-col>
                        <b-col lg="6" md="12" class="mt-2">
                            <div class="d-flex align-items-center justify-content-between">
                                <div>
                                    <h5 class="text-secondary">شماره همراه مشتری</h5>
                                    <h5 class="mb-0">{{ commentDetails.customerPhoneNumber }}
                                    </h5>
                                </div>
                                <b-media no-body>
                                    <b-media-aside class="mr-0">
                                        <b-avatar rounded size="48" variant="light-secondary">
                                            <feather-icon size="20" icon="PhoneIcon" />
                                        </b-avatar>
                                    </b-media-aside>
                                </b-media>
                            </div>
                        </b-col>
                        <b-col lg="6" md="12" class="mt-2">
                            <div class="d-flex align-items-center justify-content-between">
                                <div>
                                    <h5 class="text-secondary">شماره اشتراک مشتری</h5>
                                    <h5 class="mb-0">
                                        {{ commentDetails.customerNumber }}
                                    </h5>
                                </div>
                                <b-media no-body>
                                    <b-media-aside class="mr-0">
                                        <b-avatar rounded size="48" variant="light-secondary">
                                            <feather-icon size="20" icon="UsersIcon" />
                                        </b-avatar>
                                    </b-media-aside>
                                </b-media>
                            </div>
                        </b-col>
                        <b-col lg="6" md="12" class="mt-2">
                            <div class="d-flex align-items-center justify-content-between">
                                <div>
                                    <h5 class="text-secondary">وضعیت</h5>
                                    <h5 class="mb-0">
                                        {{ status_management(commentDetails.status) }}
                                    </h5>
                                </div>
                                <b-media no-body>
                                    <b-media-aside class="mr-0">
                                        <b-avatar rounded size="48" variant="light-secondary">
                                            <feather-icon size="20" icon="RepeatIcon" />
                                        </b-avatar>
                                    </b-media-aside>
                                </b-media>
                            </div>
                        </b-col>
                        <b-col lg="6" md="12" class="mt-2">
                            <div class="d-flex align-items-center justify-content-between">
                                <div>
                                    <h5 class="text-secondary">امتیاز داده شده</h5>
                                    <h5 v-if="!commentDetails.rate" class="mb-0">
                                        -
                                    </h5>
                                    <h5 v-else class="mb-0">
                                        <b-img v-for="n in commentDetails.rate" :key="`rate_2_${n}`"
                                            src="@/assets/images/icon/star.svg" alt="logo"
                                            style="width: 19px; height:19px;" />
                                    </h5>
                                </div>
                                <b-media no-body>
                                    <b-media-aside class="mr-0">
                                        <b-avatar rounded size="48" variant="light-secondary">
                                            <feather-icon size="20" icon="StarIcon" />
                                        </b-avatar>
                                    </b-media-aside>
                                </b-media>
                            </div>
                        </b-col>
                        <b-col md="12" class="mt-2">
                            <div class="d-flex align-items-center justify-content-between">
                                <div>
                                    <h5 class="text-secondary">متن نظر</h5>
                                    <h5 class="mb-0">{{ commentDetails.text }}
                                    </h5>
                                </div>
                                <b-media no-body>
                                    <b-media-aside class="mr-0">
                                        <b-avatar rounded size="48" variant="light-secondary">
                                            <feather-icon size="20" icon="FileTextIcon" />
                                        </b-avatar>
                                    </b-media-aside>
                                </b-media>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="mt-2 pt-50">
                        <b-col md="6">
                            <b-button type="submit" variant="danger" @click="customerCommentsStatus(2)"
                                :disabled="loadingButton"
                                class="w-100 d-flex align-items-center justify-content-center">
                                <b-spinner v-if="loadingButton" class="mr-50" variant="white" small></b-spinner>
                                <span>رد و عدم نمایش</span>
                            </b-button>
                        </b-col>
                        <b-col md="6" class="mt-1 mt-md-0">
                            <b-button type="submit" variant="success" @click="customerCommentsStatus(1)"
                                :disabled="loadingButton"
                                class="w-100 d-flex align-items-center justify-content-center">
                                <b-spinner v-if="loadingButton" class="mr-50" variant="white" small></b-spinner>
                                <span>تأیید و نمایش</span>
                            </b-button>
                        </b-col>
                    </b-row>
                </div>
            </b-modal>

            <!------------------------------- modal comments settings ------------------------------->
            <b-modal id="comments-settings" title="تنظیمات امتیاز و نظرات مشتریان" centered :hide-footer="true"
                title-class="font-weight-bolder" size="md">
                <div class="p-1">
                    <b-row>
                        <b-col md="12">
                            <b-form-group label="سیستم امتیاز و نظرات" label-for="customerCommentsEnabledId"
                                class="text-center">
                                <v-select v-model="form.customerCommentsEnabled" :searchable="false" dir="rtl"
                                    :options="customerCommentsEnabledManagement" class="bg-white" id="isReturnedId"
                                    autocomplete="off" :reduce="(value) => value.id" style="border-radius: 6px;"
                                    label="name" :clearable="false">
                                    <template #no-options>
                                        موردی وجود ندارد
                                    </template>
                                </v-select>
                            </b-form-group>
                        </b-col>
                        <b-col md="12" class="mt-25">
                            <b-form-group label-for="walletAmount" label="مبلغ پاداش ثبت نظر (ریال)"
                                class="text-center">
                                <cleave id="walletAmount" dir="ltr" v-model="walletAmount"
                                    class="form-control mt-50 text-center" autocomplete="off" :options="options.number"
                                    inputmode="numeric" />
                            </b-form-group>
                        </b-col>
                        <b-col md="12" class="mt-25">
                            <b-form-group label="امتیاز پاداش ثبت نظر" label-for="scoreId" class="text-center">
                                <b-form-input dir="ltr" type="number" v-model="form.score" id="scoreId"
                                    autocomplete="off" class="text-center" name="scoreId" />
                            </b-form-group>
                        </b-col>
                        <b-col md="12" class="mt-25">
                            <b-form-group label="پیام سیستمی بعد از ثبت نظر"
                                label-for="customerCommentPostSubmitMessageId" class="text-center">
                                <b-form-input autocomplete="off" dir="rtl" id="customerCommentPostSubmitMessageId"
                                    v-model="form.customerCommentPostSubmitMessage"
                                    name="customerCommentPostSubmitMessage" class="text-center" />
                            </b-form-group>
                        </b-col>
                        <b-col md="12" class="mt-50">
                            <b-button type="submit" variant="primary" @click="customerCommentsSettings"
                                :disabled="loadingButton"
                                class="w-100 d-flex align-items-center justify-content-center">
                                <b-spinner v-if="loadingButton" class="mr-50" variant="white" small></b-spinner>
                                <span>ذخیره تغییرات</span>
                            </b-button>
                        </b-col>
                    </b-row>
                </div>
            </b-modal>
        </div>

        <b-card v-else>
            <div class="d-flex align-items-center justify-content-center flex-wrap text-danger text-center">
                <span>برای دسترسی به این قسمت، لطفا</span>
                <router-link class="mx-25" to="/identity-management">هویت</router-link>
                <span>خود را تایید کنید.</span>
            </div>
        </b-card>
    </div>
</template>


<script>
import { BCard, BCardText, BCardBody, BButton, BRow, BCol, BForm, BImg, BFormRadio, BFormTextarea, BTable, BBadge, BPagination, BOverlay, BAvatar, BMediaAside, BMedia, BFormFile, BMediaBody, BFormInput, BFormGroup, BSpinner } from 'bootstrap-vue';
import { storeService } from '@core/services';
import vSelect from 'vue-select';
import Cleave from 'vue-cleave-component'
import 'cleave.js/dist/addons/cleave-phone.ir'
import { accessHandling } from '@core/mixins/accessHandling';

export default {
    components: {
        Cleave,
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BRow,
        BCol,
        BTable,
        BImg,
        BPagination,
        BOverlay,
        BAvatar,
        BMediaAside,
        BMedia,
        BSpinner,
        BBadge,
        BMediaBody,
        BFormInput,
        BFormGroup,
        BForm,
        BFormRadio,
        BFormTextarea,
        BFormFile,
        vSelect
    },
    mixins: [accessHandling],
    data() {
        return {
            options: {
                number: {
                    numeral: true,
                    numeralThousandsGroupStyle: 'thousand',
                },
            },
            isAdminIdentityVerified: false,
            loadingButton: false,
            loadingPage: true,
            loading: false,
            currentDate: '',
            storeId: null,
            parameters: {
                pageIndex: 1,
                pageSize: 12,
                totalCount: null,
                status: null,
                from: null,
                to: null,
            },
            comments: [],
            commentDetails: null,
            statusManagement: [
                { name: 'همه', id: null },
                { name: 'در حال بررسی', id: 0 },
                { name: 'تایید شده', id: 1 },
                { name: 'رد شده', id: 2 },
            ],
            customerCommentsEnabledManagement: [
                { name: 'غیرفعال', id: false },
                { name: 'فعال', id: true },
            ],
            fields: [
                {
                    key: 'createdAt',
                    label: 'تاریخ',
                },
                {
                    key: 'customer',
                    label: 'نام مشتری',
                },
                {
                    key: 'rate',
                    label: 'امتیاز داده شده',
                },
                {
                    key: 'status',
                    label: 'وضعیت',
                },
                {
                    key: 'details',
                    label: 'جزئیات',
                },
            ],
            form: {
                walletAmount: null,
                score: null,
                customerCommentsEnabled: false,
                customerCommentPostSubmitMessage: null
            },
            walletAmount: null
        }
    },
    computed: {
        status_management() {
            return (status) => {
                if (status == 0) {
                    return 'در حال بررسی'
                }
                if (status == 1) {
                    return 'تایید شده'
                }
                if (status == 2) {
                    return 'رد شده'
                }
            }
        },
        status_management_color() {
            return (status) => {
                if (status == 0) {
                    return 'text-warning'
                }
                if (status == 1) {
                    return 'text-success'
                }
                if (status == 2) {
                    return 'text-danger'
                }
            }
        },
    },
    methods: {
        formatDate2(date) {
            return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
        },
        formatDate(dateString) {
            const [year, month, day] = dateString.split('-');
            return new Date(year, parseInt(month) - 1, day).toLocaleDateString('fa-IR');
        },
        showDetails(item) {
            this.commentDetails = item
            this.$bvModal.show('comments-details')
        },
        customerCommentsStatus(st) {
            this.loadingButton = true
            storeService.customerCommentsStatus(this.storeId, this.commentDetails.id, { status: st }).then(({ data }) => {
                this.loadingButton = false
                this.$bvModal.hide('comments-details')
                this.getCustomerComments()
            })
        },
        customerCommentsSettings() {
            this.loadingButton = true
            this.walletAmount ? this.form.walletAmount = Number(this.walletAmount) : this.form.walletAmount = null
            this.form.score ? this.form.score = Number(this.form.score) : this.form.score = null
            storeService.customerCommentsSettings(this.storeId, this.form).then(({ data }) => {
                this.$bvModal.hide('comments-settings')
                this.loadingButton = false;
            })
        },
        getCustomerCommentsSettings() {
            if (this.accessHandling('employee', 'customer_comments_settings')) {
                this.loadingButton = true
                storeService.getCustomerCommentsSettings(this.storeId).then(({ data }) => {
                    this.form = data
                    this.walletAmount = data.walletAmount ? String(data.walletAmount) : null
                    this.$bvModal.show('comments-settings')
                    this.loadingButton = false;
                })
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        getCustomerComments() {
            this.loading = true;
            storeService.getCustomerComments(this.storeId, this.parameters).then(({ data }) => {
                if (this.loadingPage) {
                    this.parameters.totalCount = data.totalCount
                    this.comments = data.items
                    this.loading = false;
                }
                else {
                    setTimeout(() => {
                        this.parameters.totalCount = data.totalCount
                        this.comments = data.items
                        this.loading = false;
                    }, 369)
                }
                this.loadingPage = false;
            })
        },
        getCompletionStatus() {
            this.loadingPage = true;
            storeService.getCompletionStatus(this.storeId).then(({ data }) => {
                this.isAdminIdentityVerified = data.isAdminIdentityVerified;
                if (this.isAdminIdentityVerified) {
                    this.getCustomerComments()
                }
                else {
                    this.loadingPage = false;
                }
            })
        },
    },
    mounted() {
        this.storeId = localStorage.getItem("storeId")
        const tomorrow = new Date();
        const today = new Date();
        tomorrow.setDate(today.getDate() + 1);
        this.currentDate = this.formatDate2(tomorrow);
        this.getCompletionStatus()
    },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>